(function () {
    "use strict";

    angular
        .module("PWAPoCApp")
        .controller("uploadCacheModalController", uploadCacheModalController);

    uploadCacheModalController.$inject = [
        "$scope",
        "$windowInstance",
        "translateService"
    ];

    function uploadCacheModalController(
        $scope,
        $windowInstance,
        translateService
    ) {

        $scope.uploadFile = uploadFile;
        $scope.translate = translateService.translate;

        function uploadFile(e) {
            e.preventDefault();

            const intentionConfirm = confirm(translateService.translate('diagnostics.confirm'));
            
            if (!intentionConfirm) return;

            const fileInputEl = document.getElementById('indexedDbFileUpload');
            const file = fileInputEl.files[0];

            if (file){
                const reader = new FileReader();
                reader.readAsText(file, "UTF-8");
                reader.onload = function (evt) {
                    loadToIndexedDb(evt.target.result);
                    $windowInstance.close();
                }
                reader.onerror = function (evt) {
                    alert(translateService.translate('diagnostics.errorReadingFile'));
                }
                reader.onloadend = function (evt) {
                    fileInputEl.value = null;
                }
            }

        }

        function loadToIndexedDb(text){
            
            try {

                if (!text || typeof text !== 'string') throw translateService.translate('diagnostics.errorInvalidData');

                const data = JSON.parse(text.replaceAll('\n',' '));
                const request = indexedDB.open('DTA');

                request.onsuccess = function (e) {

                    const db = e.target.result;
                    const trans = db.transaction('keyvaluepairs', 'readwrite');
                    const objStore = trans.objectStore('keyvaluepairs');
                    const authDataRequest = objStore.get('authData');
                    let authToken = '';
                    
                    authDataRequest.onsuccess = function (event) {
                        authToken = event.target.result.token;
                    }
                    authDataRequest.onerror = function (event) {
                        throw translateService.translate('diagnostics.errorCouldNotOpen');
                    }

                    const insertRequest = objStore.clear();

                    insertRequest.onsuccess = function (evt) {
                        data.forEach(item => {
                            if (item.key === 'authData') item.value.token = authToken;
                            objStore.put(item.value, item.key);
                        })
                        alert(translateService.translate('diagnostics.successfullyImported'));
                    }

                    insertRequest.onerror = function (e) {
                        throw translateService.translate('diagnostics.errorCouldNotRewrite');
                    }

                }
                request.onerror = function (e) {
                    throw translateService.translate('diagnostics.errorCouldNotOpen');
                }

            } catch (error) {

                alert(error);

            }
        }

    }
})();
